/**
 * Sun-Spot - Labels et constantes pour les enums
 * Version française des labels
 */

export const WEATHER_OPTIONS = [
  { value: 'clear', label: 'Ciel dégagé', icon: '☀️' },
  { value: 'partly_cloudy', label: 'Partiellement nuageux', icon: '⛅' },
  { value: 'cloudy', label: 'Nuageux', icon: '☁️' },
  { value: 'fog', label: 'Brouillard', icon: '🌫️' },
  { value: 'mist', label: 'Brume', icon: '🌁' },
  { value: 'after_rain', label: 'Après la pluie', icon: '🌈' },
  { value: 'snow', label: 'Neige', icon: '❄️' },
  { value: 'windy', label: 'Venteux', icon: '💨' }
];

export const LIGHT_OPTIONS = [
  { value: 'sunrise', label: 'Lever de soleil', icon: '🌅' },
  { value: 'sunset', label: 'Coucher de soleil', icon: '🌇' },
  { value: 'golden_hour', label: 'Heure dorée', icon: '🌤️' },
  { value: 'blue_hour', label: 'Heure bleue', icon: '🌆' },
  { value: 'overcast_soft_light', label: 'Lumière douce (couvert)', icon: '🌥️' },
  { value: 'full_moon', label: 'Pleine lune', icon: '🌕' },
  { value: 'night_sky', label: 'Ciel nocturne', icon: '🌌' }
];

export const CROWD_LEVEL_OPTIONS = [
  { value: 'very_quiet', label: 'Très calme', icon: '🧍', description: 'Presque personne' },
  { value: 'quiet', label: 'Calme', icon: '🧍‍♂️', description: 'Peu de monde' },
  { value: 'moderate', label: 'Modéré', icon: '👥', description: 'Fréquentation normale' },
  { value: 'popular', label: 'Populaire', icon: '👨‍👩‍👧', description: 'Assez fréquenté' },
  { value: 'crowded', label: 'Très fréquenté', icon: '👨‍👩‍👧‍👦', description: 'Beaucoup de monde' }
];

export const DIFFICULTY_OPTIONS = [
  { value: 'easy', label: 'Facile', icon: '🟢', description: 'Accessible à tous' },
  { value: 'moderate', label: 'Modéré', icon: '🟡', description: 'Marche requise' },
  { value: 'hard', label: 'Difficile', icon: '🔴', description: 'Randonnée/escalade' }
];

export const TIME_WINDOW_OPTIONS = [
  { value: 'sunrise', label: 'Lever de soleil', icon: '🌅', period: 'morning' },
  { value: 'golden_hour_am', label: 'Heure dorée (matin)', icon: '🌤️', period: 'morning' },
  { value: 'morning', label: 'Matin', icon: '☀️', period: 'morning' },
  { value: 'afternoon', label: 'Après-midi', icon: '🌞', period: 'afternoon' },
  { value: 'golden_hour_pm', label: 'Heure dorée (soir)', icon: '🌅', period: 'evening' },
  { value: 'sunset', label: 'Coucher de soleil', icon: '🌇', period: 'evening' },
  { value: 'blue_hour_am', label: 'Heure bleue (matin)', icon: '🌆', period: 'morning' },
  { value: 'blue_hour_pm', label: 'Heure bleue (soir)', icon: '🌃', period: 'evening' },
  { value: 'night', label: 'Nuit', icon: '🌙', period: 'night' }
];

// Fonction utilitaire pour obtenir le label d'une valeur
export const getLabel = (options, value) => {
  const option = options.find(opt => opt.value === value);
  return option ? option.label : value;
};

// Fonction utilitaire pour obtenir l'icône d'une valeur
export const getIcon = (options, value) => {
  const option = options.find(opt => opt.value === value);
  return option ? option.icon : '';
};

// Export des labels comme objet pour compatibilité
export const WEATHER_LABELS = Object.fromEntries(WEATHER_OPTIONS.map(o => [o.value, o.label]));
export const LIGHT_LABELS = Object.fromEntries(LIGHT_OPTIONS.map(o => [o.value, o.label]));
export const CROWD_LEVEL_LABELS = Object.fromEntries(CROWD_LEVEL_OPTIONS.map(o => [o.value, o.label]));
export const DIFFICULTY_LABELS = Object.fromEntries(DIFFICULTY_OPTIONS.map(o => [o.value, o.label]));
export const TIME_WINDOW_LABELS = Object.fromEntries(TIME_WINDOW_OPTIONS.map(o => [o.value, o.label]));
